const TRANSITION_BASE = "transition-all duration-300 ease-out";
const TRANSITION_VISIBILITY = "transition-all duration-300 ease-out overflow-hidden";

export const getDesktopCenterContentClassName = (isCollapsed: boolean) =>
  [
    "flex justify-center relative",
    TRANSITION_BASE,
    isCollapsed ? "overflow-visible" : "w-full min-w-0 overflow-hidden",
  ].join(" ");

export const getDesktopSearchBarContainerClassName = (isCollapsed: boolean) =>
  [
    TRANSITION_VISIBILITY,
    isCollapsed ? "opacity-0 w-0 h-0" : "opacity-100 w-full min-w-0 h-auto",
  ].join(" ");

export const getDesktopCompactNavItemsClassName = (isCollapsed: boolean) =>
  [
    TRANSITION_BASE,
    isCollapsed ? "opacity-100 w-auto overflow-visible" : "opacity-0 w-0 h-0 overflow-hidden",
  ].join(" ");

export const getMobileSearchBarRowClassName = () => "w-full items-center justify-center";

export const getMobileSearchBarContainerClassName = () => "w-full";
